.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.header {
  background-color: var(--color-easil-black);
  min-width: 768px;
}

.subHeader {
  background-color: var(--color-easil-black);
  min-width: 768px;
  padding-bottom: 48px;
}

.subHeaderNoPadding {
  background-color: var(--color-easil-black);
  min-width: 768px;
  padding-bottom: 0px;
}

.gutters {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding-bottom: 48px;
  min-width: 768px;
}

.subHeaderGutters {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  min-width: 768px;
}

.content {
  max-width: var(--layout-width);
  width: 100%;
}

@media screen and (max-width: var(--layout-width)) {
  .content {
    padding: 0 24px 0 24px;
  }
}

@media (max-width: 640px) {
  .header {
    min-width: 0;
  }

  .header .content {
    padding: 0;
  }

  .subHeader {
    min-width: 0;
    padding-bottom: 24px;
  }

  .subHeaderNoPadding {
    min-width: 0;
  }

  .gutters {
    min-width: 0;
    padding-bottom: 24px;
  }

  .subHeaderGutters {
    min-width: 0;
  }

  .content {
    max-width: 100%;
    padding: 0 8px;
  }
}
